// Types
import {
  ChangeIbanEventType,
  IbanSelectorHandlersType,
  IbanSelectorHandlersBuilderType,
  IbanSelectorHandlersChangeBuilderType,
  IbanSelectorHandlersSetupBuilderType,
} from './types/iban-selector.handlers.type';

const changeIbanHandler = ({
  event,
  setIbanList,
  setSelectedIban,
}: IbanSelectorHandlersChangeBuilderType): void => {
  const value = event.target.value;

  setIbanList(prev =>
    prev.map(iban => ({
      ...iban,
      selected: iban.iban === value,
    }))
  );
  setSelectedIban(value);
};

const setupIbanListHandler = ({
  flowApiData,
  setIbanList,
}: IbanSelectorHandlersSetupBuilderType): void => {
  setIbanList(flowApiData?.accounts);
};

const IbanSelectorHandlers = ({
  flowApiData,
  setIbanList,
  setSelectedIban,
}: IbanSelectorHandlersBuilderType): IbanSelectorHandlersType => ({
  handleChangeIban: (event: ChangeIbanEventType) =>
    changeIbanHandler({ event, setIbanList, setSelectedIban }),
  handleSetupIbanList: () => setupIbanListHandler({ flowApiData, setIbanList }),
});

export { IbanSelectorHandlers };
